import { Link } from "react-router-dom";
import { Instagram, Linkedin } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#070E13] text-[#F4EEE8] pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <img
              src="/logo-white.png"
              alt="Carol Stoffella"
              className="h-6 w-auto object-contain"
            />
            <p className="font-serif text-3xl sm:text-4xl mt-3 leading-tight">
              {t.footer.tagline}
            </p>
            <p className="text-sm mt-6 text-[#F4EEE8]/70 max-w-md">
              {t.contact.regions}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-[#F4EEE8]/50 mb-5">{t.footer.navigate}</p>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-about" className="hover:text-[#C7A26C]" to="/about">{t.nav.about}</Link></li>
              <li><Link data-testid="footer-link-services" className="hover:text-[#C7A26C]" to="/services">{t.nav.services}</Link></li>
              <li><Link data-testid="footer-link-spa" className="hover:text-[#C7A26C]" to="/spa-at-home">{t.nav.spa}</Link></li>
              <li><Link data-testid="footer-link-philosophy" className="hover:text-[#C7A26C]" to="/philosophy">{t.nav.philosophy}</Link></li>
              <li><Link data-testid="footer-link-testimonials" className="hover:text-[#C7A26C]" to="/testimonials">{t.nav.testimonials}</Link></li>
              <li><Link data-testid="footer-link-contact" className="hover:text-[#C7A26C]" to="/contact">{t.nav.contact}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-[#F4EEE8]/50 mb-5">{t.footer.direct}</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a data-testid="footer-email" className="hover:text-[#C7A26C]" href="mailto:carol@carolstoffella.com">
                  carol@carolstoffella.com
                </a>
              </li>
              <li>
                <a data-testid="footer-whatsapp" className="hover:text-[#C7A26C]" href="https://wa.me/971558441468" target="_blank" rel="noreferrer">
                  +971 55 844 1468 — WhatsApp Business
                </a>
              </li>
            </ul>

            <p className="overline text-[#F4EEE8]/50 mt-8 mb-4">{t.footer.follow}</p>
            <div className="flex items-center gap-3">
              <a
                data-testid="footer-instagram"
                href="https://www.instagram.com/carolstoffella"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-[#C7A26C]/40 text-[#C7A26C] hover:bg-[#C7A26C] hover:text-[#070E13] hover:border-[#C7A26C] transition-all"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a
                data-testid="footer-linkedin"
                href="https://www.linkedin.com/in/c%CE%BBrol-stoff%CE%BEll%CE%BB%C2%AE-a6092360/"
                target="_blank"
                rel="noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 flex items-center justify-center rounded-full border border-[#C7A26C]/40 text-[#C7A26C] hover:bg-[#C7A26C] hover:text-[#070E13] hover:border-[#C7A26C] transition-all"
              >
                <Linkedin size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-[#F4EEE8]/50 tracking-wide">
          <p>© {year} CΛROL STOFFΞLLΛ®. {t.footer.rights}</p>
          <p className="font-serif italic">
            <span className="text-[#2FB7B1]">Reset</span> · <span className="text-[#C7A26C]">Rebuild</span> · <span className="text-[#C77D66]">Sustain</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
